import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, Button, Stack } from "@mui/material";
import Link from "@shared/components/contents/link/Link";
import Icon from "@shared/components/Icon";
const style = {
    position: "relative",
    flexDirection: { xs: "column", md: "row" },
    alignItems: { xs: "flex-start", md: "center" },
    width: "100%",
    minHeight: "164px",
    margin: "0 auto",
    p: { xs: 2.5, md: "32px 40px" },
    gap: { xs: 2.5, md: 3 },
    borderWidth: { xs: "0px 1px 1px 1px", md: "1px 1px 1px 0px" },
    borderStyle: "solid",
    borderColor: "border.default",
};
const dynamicBar = (barColor) => ({
    "&::before": {
        content: '""',
        position: "absolute",
        left: 0,
        top: 0,
        width: { xs: "100%", md: "4px" },
        height: { xs: "4px", md: "100%" },
        backgroundColor: barColor || "border.active" || "primary.main",
        transition: { xs: "height 0.5s ease-out", md: "width 0.8s ease-out" },
        zIndex: -1,
    },
    "&:hover::before, &:focus-within::before": {
        width: "100%",
        height: "100%",
    },
});
const SolutionCard = (props) => {
    const { id, label, title, question, description, buttonLink, barColor } = props;
    const hasLink = buttonLink && (buttonLink.page || buttonLink.url);
    return (_jsx(Box, { component: hasLink ? Link : "div", ...(hasLink ? buttonLink : {}), sx: {
            display: "block",
            "&:hover": {
                textDecoration: "none",
                "& .MuiTypography-root, & .MuiButton-root": {
                    color: "text.primary",
                    transition: "color 0.5s ease",
                },
            },
            "& .MuiTypography-root, & .MuiButton-root": {
                transition: "color 0.7s ease",
            },
        }, children: _jsxs(Stack, { sx: {
                ...style,
                ...dynamicBar(barColor),
            }, children: [(label || title) && (_jsxs(Box, { sx: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "4px",
                        maxWidth: "280px",
                        flexShrink: 0,
                    }, children: [label && (_jsx(Typography, { variant: "body2", color: "text.primary", sx: { fontSize: { xs: 12, md: 14 } }, children: label })), title && (_jsx(Typography, { variant: "h5", component: "h3", color: "text.primary", sx: {
                                fontWeight: 600,
                                letterSpacing: { xs: "0.02em", md: "-0.02em" },
                                fontSize: { xs: 16, md: 20 },
                                lineHeight: { xs: 1.25, md: 1.35 },
                            }, children: title }))] })), (question || description) && (_jsxs(Box, { sx: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "16px",
                        flex: 1,
                        minWidth: 0,
                    }, children: [question && (_jsx(Typography, { variant: "body2", sx: { fontWeight: 600, width: "100%" }, color: "text.primary", children: question })), description && (_jsx(Typography, { variant: "body2", sx: { width: "100%" }, color: "text.secondary", children: description }))] })), buttonLink && (buttonLink.page || buttonLink.url) && (_jsx(Button, { component: "span", variant: "text", size: "small", color: "primary", endIcon: _jsx(Icon, { icon: "long-arrow-right" }), sx: {
                        flexShrink: 0,
                        fontSize: "14px !important",
                        whiteSpace: { xs: "normal", md: "initial" },
                        color: "primary.main",
                    }, children: buttonLink.title }))] }, id) }));
};
export default SolutionCard;
